// extracted by mini-css-extract-plugin
export default {"footer-box":"HeaderList_footer-box__+ivRI","header-table":"HeaderList_header-table__HXlyD"};